const BillingInformationModel = Backbone.Model.extend({
  urlRoot: "/billing-information",
  paramRoot: "billing_information",

  sync: function(method, model, options) {
    options = options || {};

    options.headers = options.headers || {};
    options.headers['X-CSRF-Token'] = $("meta[name='csrf-token']").attr("content");

    return Backbone.sync(method, model, options);
  }
});

document.addEventListener("turbo:load", () => App.billing_information = new BillingInformationModel());
